<div class="rp-settings">
  @if (loading()) {
  <div class="rp-settings__status">
    <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>Loading settings…
  </div>
  }
  @if (loadError()) {
  <div class="alert alert-danger py-2" role="alert">{{ loadError() }}</div>
  }

  @if (settings()) {
    <div class="rp-settings__head">
      <app-registration-platform-logo [name]="settings().platform.name" [image]="settings().platform.image"></app-registration-platform-logo>
      <div class="rp-settings__name">{{ settings().platform.name }}</div>
      @if (settings().platform.guide_url) {
      <a
        class="rp-settings__guide"
        target="_blank"
        rel="noopener noreferrer"
        [href]="settings().platform.guide_url">
        <i class="fa fa-book me-1" aria-hidden="true"></i>View how-to guide
      </a>
      }
    </div>

    <app-sb-input-form
      mode="edit"
      [embedded]="true"
      [showHeader]="false"
      [loading]="saving()"
      [disabled]="!settings().can_manage"
      [error]="banner"
      [submitLabel]="submitLabel"
      (submitted)="save()"
      (cancelled)="cancel()">
      <app-sb-input-text
        class="rp-settings__name-field"
        label="Name"
        description="How this platform is named in this project; another install of the same platform needs a name of its own."
        [required]="true"
        [disabled]="!settings().can_manage"
        [error]="nameError()"
        [ngModel]="name()"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="onNameChange($event)">
      </app-sb-input-text>
      <app-sb-schema-form
        #settingsForm
        [schema]="settings().form"
        [values]="settings().values"
        [options]="settings().options"
        [fieldMapping]="settings().field_mapping"
        [serverErrors]="refusal()"
        (formErrorsChange)="formErrors = $event">
      </app-sb-schema-form>
    </app-sb-input-form>
  }
</div>
